export default class FeatureEntity {
    static getEntityData(elem: any) {
        return {
            uuid: elem.querySelector("#site_feature_uuid") ? (elem.querySelector("#site_feature_uuid") as HTMLInputElement).value : null,
            users: Array.from(elem.querySelectorAll("#site_feature_users option:checked")).map(o => o.value)
        }
    }
}